package cz.lhoracek.mapl.data.model

import kotlinx.serialization.Serializable

enum class SessionStatus { ACTIVE, FINISHED }

@Serializable
data class Session(
    val id: String,
    val name: String,
    val baseBet: Int,
    val currentBet: Int,
    val potEnabled: Boolean = false,
    val potAmount: Int = 0,
    val status: SessionStatus = SessionStatus.ACTIVE,
    val createdAt: Long = 0L,
    val playerIds: List<String> = emptyList(),
)
